import { MinusIcon } from "lucide-react";
import { roundNumber, useLemonadeContext } from "../LemonadeProvider";
import "../styles/LemonadeList.css";

export function LemonadeList() {
    const { lemonades, removeLemonade } = useLemonadeContext();

    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat("hu-HU", {
            style: "currency",
            currency: "HUF",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    };

    return (
        <section className="lemonades-section">
            <h1 className="main-title">Elérhető limonádék</h1>
            {!lemonades.length ? (
                <div className="lemonades-empty">Nincs elérhető limonádé.</div>
            ) : (
                <div className="lemonades-list">
                    {lemonades.map((lemonade) => (
                        <div className="lemonade-card" key={lemonade.name}>
                            <h2 className="lemonade-title">{lemonade.name}</h2>
                            <div className="lemonade-price">{formatCurrency(lemonade.price)}</div>
                            <h3 className="ingredients-title">Hozzávalók 1 literhez</h3>
                            <ul className="lemonade-ingredients">
                                {lemonade.ingredients
                                    .toSorted((a, b) => a.name.localeCompare(b.name))
                                    .map((ing) => (
                                        <li key={ing.name}>
                                            {ing.name} – {roundNumber(ing.amount.amount, 2)} {ing.amount.unit}
                                        </li>
                                    ))}
                            </ul>
                            <button
                                className="lemonade-remove-button"
                                onClick={() => {
                                    if (confirm(`Biztosan törlöd a "${lemonade.name}" limonádét?`)) {
                                        removeLemonade(lemonade);
                                    }
                                }}
                            >
                                <MinusIcon strokeWidth={"2.5px"} />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
}
